module.exports = __webpack_public_path__ + "img/SI.cab53f91.svg";